import { Component, OnInit } from '@angular/core';
import { TenantsService } from './../services/tenants.service';
import { Tenant } from './../config.types';

// use list-templates for output and style
@Component({
  selector: 'b4a-admin-tenants',
  templateUrl: './tenants.component.html',
  styleUrls: ['./tenants.component.css']
})
export class TenantsComponent implements OnInit {
  // tenant data for output
  tenants: Tenant[];
  
  // call with api result to display
  prepareData(tenants: Tenant[]){
    this.tenants = tenants;
  };

  // override constructor with service for api-call
  constructor(private tenantsService: TenantsService){}

  // on initialization load tenant list and call default prepareData-method 
  ngOnInit(): void {
    this.tenantsService.loadTenants().subscribe(
      // success 
      (response) => { this.prepareData(response); },
      // error 
      (error) => { console.error(error); },
      // complete 
      () => { }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/config/tenants/tenants.component.ts